const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/disclosure"],
    exact: true,
    component: "AffiliateDisclosure",
  },
  {
    path: ["/priceHistory", "/priceHistory/:query"],
    exact: false,
    component: "ProductPriceHistory",
  },
];

export default routes;
